// extracted by mini-css-extract-plugin
export default {"container":"OK-z","dimension":"PK-z","dimensionLabels":"QK-z"};